<template>
  <RevLink
    :aria-label="i18n(translations.iconAltText)"
    :class="[
      'relative h-20 w-20 md:h-24 md:w-24',
      {
        ['bubbleIcon after:bg-purple-500 after:border-dark after:rounded-full after:absolute after:left-4 after:top-[0.2rem] after:h-2 after:w-2']:
          hasCartItems,
      },
    ]"
    :to="resolveLocalizedRoute({ name: CHECKOUT.CART })"
    @click="
      trackClick({
        zone: 'header',
        name: 'cart',
      })
    "
  >
    <IconShoppingBag class="mr-20 h-full w-full" />
  </RevLink>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useUserStore } from '@backmarket/nuxt-module-oauth/useUserStore'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevLink } from '@ds/components/Link'
import { IconShoppingBag } from '@ds/icons/IconShoppingBag'
import { storeToRefs } from 'pinia'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './CartIconAndBubble.translations'

const i18n = useI18n()

const { trackClick } = useTracking()
const userStore = useUserStore()
const resolveLocalizedRoute = useRouteLocationWithLocale()

const { user } = storeToRefs(userStore)
const hasCartItems = computed(() => user.value.cartItemsCount > 0)
</script>
